type Props = {
    className?: string;
    id?: string;
};

const Illustration = ({ className, id }: Props) => (
    <svg
        className={`${className}`}
        id={`${id}`}
        aria-hidden="true"
        role="img"
        focusable="false"
        aria-label="Dekorativ illustrasjon av en postmann"
        width="92"
        height="94"
        viewBox="0 0 92 94"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="57.0577" cy="49.9808" r="34.9423" fill="#E0F2FE" />
        <mask
            id="mask0_1629_36312"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="89"
            height="94"
        >
            <path
                d="M80.5 76.0769L88.4615 2.64064V0H37.1891V43.7907H0V82.08L18.0444 93.3027L44.8909 83.8404L49.3697 84.5142C60.4701 86.1841 71.7621 83.1236 80.5 76.0769Z"
                fill="#C4C4C4"
            />
        </mask>
        <g mask="url(#mask0_1629_36312)">
            <g clipPath="url(#clip0_1629_36312)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M53.7727 47.2172C57.1336 45.9516 57.3756 46.7464 56.6002 50.0094C55.5953 54.2347 53.5656 59.2373 51.1311 63.2698C51.1158 63.4994 51.0767 63.7347 51.0128 63.9753C50.6617 65.2939 49.8635 66.2481 48.5967 66.7331C46.0519 69.042 42.7569 68.2233 41.092 65.9643L41.0123 65.935C35.3881 63.8458 30.4135 59.5646 30.8443 58.4422C31.3667 57.0821 34.893 56.2043 38.8645 56.4846C39.9268 56.5587 41.0255 56.7004 42.1088 56.9075C44.5652 52.7866 48.6913 49.13 53.7727 47.2172Z"
                    fill="#909296"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.495 53.1321C28.4445 51.021 31.5065 50.5913 34.4441 53.2828C36.2097 54.9027 38.0381 58.9043 36.7075 60.7715C35.4021 62.6071 30.167 62.8237 27.6205 60.6742C25.3325 58.7439 23.9649 55.8715 26.495 53.1321Z"
                    fill="#F0D9B4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M53.1444 47.0438C48.686 48.7205 43.8106 53.7095 42.393 62.7357C41.2299 70.1367 37.7166 73.1721 37.7166 73.1721C37.7166 73.1721 39.5943 75.6492 42.2659 76.8592C45.345 78.255 48.0918 78.1913 48.0918 78.1913C48.0918 78.1913 55.1465 63.4415 56.7295 56.5771C58.3132 49.7147 57.0372 45.5795 53.1444 47.0438Z"
                    fill="#767676"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M57.5289 61.9431C59.3357 61.8791 61.138 62.51 62.6422 63.6048C68.1295 62.2922 74.4751 65.1949 74.2002 74.9917C73.9485 84.1248 71.0848 92.3419 69.6557 93.0264C68.9847 93.3513 62.215 89.6799 58.235 84.3671L57.8264 84.9845C54.7683 89.6281 52.6378 93.3528 51.4869 93.2893C49.9771 93.203 45.847 87.872 44.878 79.2322C43.7156 68.8781 50.7204 62.185 57.5289 61.9431Z"
                    fill="#474445"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M44.7311 74.7599C42.6298 67.1459 44.0713 58.5794 50.6248 50.0513C59.069 39.0606 72.3955 42.107 75.5601 51.419C78.7514 60.8118 76.7308 72.5727 73.0219 76.9875C70.5684 79.9065 45.7281 78.3716 44.7311 74.7599Z"
                    fill="#FCD34D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M70.1838 45.1043C67.6613 45.1602 60.1026 51.6601 58.6208 66.2324C57.8509 73.8012 58.0594 80.6491 58.0594 80.6491C58.0594 80.6491 61.5338 81.0596 66.6705 80.3936C71.4119 79.7789 74.1081 78.1392 74.1081 78.1392C74.1081 78.1392 78.3983 69.4549 78.6185 60.97C78.8865 50.5863 72.4725 45.0547 70.1838 45.1043Z"
                    fill="#767676"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M78.2792 23.4737C78.2792 23.4737 78.4782 26.1029 80.8544 27.6898C82.9297 29.0774 85.5309 28.2805 85.5309 28.2805C85.5309 28.2805 84.7644 30.0209 82.9502 30.7383C81.5245 31.3009 80.0352 31.1474 80.0352 31.1474C80.0352 31.1474 80.0351 31.1499 80.035 31.1547L80.0349 31.1925C80.0376 31.3699 80.0855 32.0542 80.6253 32.9399C81.264 33.9903 82.0299 34.6831 82.0299 34.6831C82.0299 34.6831 80.2048 34.8715 78.734 34.6173C77.0976 34.3357 76.1075 33.8512 76.1075 33.8512C76.1075 33.8512 75.9605 34.842 76.3557 36.2118C76.6682 37.2916 76.9704 38.0625 76.9704 38.0625C76.9704 38.0625 75.4866 38.0454 74.21 37.3451C73.1364 36.7572 72.4218 35.9363 72.4218 35.9363C72.4218 35.9363 72.1647 36.49 71.9856 38.24C71.8577 39.496 71.9616 40.188 71.9616 40.188C71.9616 40.188 70.075 39.6207 69.2511 37.3451C67.6674 32.9673 70.6248 22.1527 73.5952 19.4187C76.076 17.1397 78.2792 23.4737 78.2792 23.4737ZM47.1785 27.415C47.9957 27.0066 50.8334 28.1064 50.9852 30.6163C51.1398 33.1248 49.4583 34.3836 48.2391 34.5227C46.46 34.7239 45.6113 33.9414 45.5408 33.873L45.536 33.8683C45.536 33.8683 46.3976 33.5037 46.8968 32.7349C47.3146 32.0915 47.4527 31.1987 47.4527 31.1987C47.4527 31.1987 46.3422 31.3529 45.0369 30.8143C43.5551 30.2024 42.859 28.055 42.859 28.055C42.859 28.055 43.9442 28.4935 45.2488 28.2804C46.6554 28.0488 47.1785 27.415 47.1785 27.415Z"
                    fill="#B2976C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M71.0813 45.3643C71.2735 47.0602 67.4333 48.889 62.5031 49.4474C57.5743 50.0066 53.4243 49.0863 53.2315 47.3891C53.0393 45.6911 56.8795 43.8644 61.8097 43.3045C66.7385 42.7447 70.8905 43.667 71.0813 45.3643Z"
                    fill="#FDE047"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M70.467 37.5536L68.6515 45.3896C68.6515 45.3896 65.4527 47.1438 61.2419 47.3617C57.7914 47.5405 55.3893 46.5689 55.3893 46.5689L54.1625 39.2193C54.1625 39.2193 57.3066 36.7087 60.9602 36.5032C65.7098 36.238 70.467 37.5536 70.467 37.5536Z"
                    fill="#F0D9B4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M70.467 37.5536L69.9753 39.6777C69.9753 39.6777 67.5841 42.5618 61.8033 43.3155C57.4837 43.8808 54.7472 42.7221 54.7472 42.7221L54.1625 39.2193C54.1625 39.2193 57.3066 36.7087 60.9602 36.5032C65.7098 36.238 70.467 37.5536 70.467 37.5536Z"
                    fill="#DDC59E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M49.3881 40.5112C47.4796 39.5095 45.2539 25.5538 46.4075 19.0889C47.7368 11.6441 53.6571 3.46617 63.9885 3.6731C74.2079 3.88003 79.0581 12.5363 78.4502 21.1363C77.9551 28.135 75.7663 32.1716 73.7477 34.9624C71.6026 37.9335 69.7112 39.1107 65.7767 40.2358C62.2797 41.2382 52.2505 42.0118 49.3881 40.5112Z"
                    fill="#F0D9B4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M50.7004 21.1873C52.0824 21.1873 53.2038 22.3097 53.2038 23.6973C53.2038 25.0821 52.0824 26.2065 50.7004 26.2065C49.3164 26.2065 48.197 25.0821 48.197 23.6973C48.197 22.3097 49.3164 21.1873 50.7004 21.1873ZM65.215 20.829C66.597 20.829 67.7184 21.9514 67.7184 23.3369C67.7184 24.7238 66.597 25.8461 65.215 25.8461C63.8303 25.8461 62.7096 24.7238 62.7096 23.3369C62.7096 21.9514 63.8303 20.829 65.215 20.829Z"
                    fill="#6D5A3F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M73.6062 19.857C74.5922 16.8586 78.5794 19.2136 78.2738 23.4002C78.0741 26.1301 77.0785 28.3056 75.1105 28.6256C73.2055 28.9354 72.4095 23.4969 73.6062 19.857Z"
                    fill="#B2976C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M79.8171 25.1192C82.0216 27.1693 79.7535 32.3934 77.5612 32.9367C75.3697 33.4801 73.0113 30.6646 73.5009 28.2081C73.9925 25.751 77.1735 22.6614 79.8171 25.1192Z"
                    fill="#F0D9B4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M78.2792 23.4738C78.2792 23.4738 74.3912 19.0172 65.6967 16.5662C57.1759 14.1666 46.9825 16.4853 46.9825 16.4853C46.9825 16.4853 49.2657 7.12949 51.0696 4.84021C53.0608 2.31659 58.2276 -0.0364153 66.5378 1.5889C74.7522 3.19434 77.9189 7.73247 79.2413 10.9043C80.492 13.9069 78.2792 23.4738 78.2792 23.4738Z"
                    fill="#FDE047"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M47.0089 16.4741C47.0089 16.4741 39.6102 15.0338 40.4376 9.9537C41.211 5.19082 53.0728 4.27813 59.1367 10.9712C62.7827 14.9934 67.9932 17.3026 67.9932 17.3026C67.9932 17.3026 63.9027 15.4724 56.4794 15.4689C51.7243 15.4669 47.0089 16.4741 47.0089 16.4741Z"
                    fill="#713F12"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M64.809 31.4825C64.809 31.4825 61.5774 31.8107 57.9738 31.9744C54.5582 32.13 51.343 32.0875 51.343 32.0875C51.343 32.0875 52.1984 34.4802 53.4457 35.5773C54.4283 36.444 56.1603 37.293 57.8732 37.2848C59.5191 37.2752 61.7223 36.2981 62.9176 35.0866C64.2531 33.7382 64.809 31.4825 64.809 31.4825Z"
                    fill="#905F5A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M58.2388 33.5521C59.7213 33.5083 61.865 33.8255 61.6824 34.8294C61.6147 35.2001 60.2888 36.1847 58.2169 36.2649C56.2428 36.343 54.7754 35.4783 54.7124 34.9664C54.6085 34.0914 56.5929 33.6028 58.2388 33.5521Z"
                    fill="#FF937B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2283 89.5786L64.4227 80.8956L59.7763 51.4138L31.9943 56.3172L9.02219 60.3716L15.2283 89.5786Z"
                    fill="#C9AC82"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2283 89.5786L37.0688 85.7236L32.0073 56.3152L9.02219 60.3716L15.2283 89.5786Z"
                    fill="#B2976C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8778 58.8513L16.7862 66.416L23.7212 66.6695L23.6166 57.6885L16.8778 58.8513Z"
                    fill="#917655"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M52.0599 59.9751L40.4852 68.2503L45.7258 75.4916L57.1965 67.2349L52.0599 59.9751Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M76.0576 53.1113C77.9934 57.9838 77.6624 65.208 74.6613 69.6358C74.2109 70.3001 73.7461 70.8356 73.2753 71.2538C70.9338 73.5441 66.8946 75.3365 62.8366 75.9828C58.3058 76.7057 55.5207 75.7923 54.8191 74.2643C54.2406 73.0062 58.2702 67.7164 64.5865 64.7851C64.7143 64.7258 64.8411 64.668 64.9669 64.6117C64.4461 60.5417 64.803 55.7135 66.7908 52.3987C69.2531 48.2936 74.3529 48.8205 76.0576 53.1113Z"
                    fill="#909296"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M59.2858 73.7107C59.5122 76.579 57.7528 79.1252 53.7861 79.4651C51.4023 79.6665 47.2243 78.303 46.758 76.0562C46.2971 73.8525 49.6833 69.8468 52.9888 69.4282C55.9537 69.0492 58.9898 69.9893 59.2858 73.7107Z"
                    fill="#F0D9B4"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1629_36312">
                <rect
                    width="76.5786"
                    height="102.545"
                    fill="white"
                    transform="translate(9.02219 0.88031)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default Illustration;
